<div class="app-content-new" [class.logged-in]="showNav">
  <router-outlet></router-outlet>
  <app-back-button *ngIf="showNav"></app-back-button>
  <app-bottom-nav *ngIf="showNav"></app-bottom-nav>
  <app-side-nav *ngIf="showNav"></app-side-nav>
</div>
<!-- Temporarily disabled: reported bugs (stale address after re-saving email, possible
     validation glitch on Settings). See changelog/2026-07-20-disable-email-confirmation-feature.md.
     Re-enable by uncommenting this and the EmailConfirmationBannerComponent registration in
     app.module.ts, and the SendConfirmationEmailAsync call sites in AccountController.cs. -->
<!-- <app-email-confirmation-banner></app-email-confirmation-banner> -->
